import { createSlice } from "@reduxjs/toolkit";

export interface ProjectDetailsInterface {
  streetAddress: string;
  city: string;
  state: string;
  zipCode: number | undefined;
  dealType: string;
  proposedUnits: number | undefined;
  constructionType: string;
  acquisitionType: string;
  siteControlStatus: string;
  projectByRight: string;
  acquisitionCostEstimate: number | undefined;
  developmentCostEstimate: number | undefined;
  preDevelopmentCostEstimate: number | undefined;
  moreInfo: string;
  projectDetailsIsValid: boolean;
  additionalDocs: {
    id: string;
    doc: { name: string; type: string; size: number };
  }[];
}

const initialState: ProjectDetailsInterface = {
  streetAddress: "",
  city: "",
  state: "Select",
  zipCode: undefined,
  dealType: "Select",
  proposedUnits: undefined,
  constructionType: "Select",
  acquisitionType: "Select",
  siteControlStatus: "Select",
  projectByRight: "Select",
  acquisitionCostEstimate: undefined,
  developmentCostEstimate: undefined,
  preDevelopmentCostEstimate: undefined,
  moreInfo: "",
  projectDetailsIsValid: false,
  additionalDocs: [],
};

export const projectDetailsSlice = createSlice({
  name: "projectDetails",
  initialState,
  reducers: {
    clearProjectDetails: () => initialState,
    setProjectDetails(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setProjectDetails, clearProjectDetails } =
  projectDetailsSlice.actions;

export default projectDetailsSlice.reducer;
